import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-group mb-2 col" }
const _hoisted_17 = { class: "col-auto p-0 text-end" }
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "card card-body" }
const _hoisted_20 = { class: "overflow-auto" }
const _hoisted_21 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = { class: "text-capitalize-first" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = ["title"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ManualPriorityForm = _resolveComponent("ManualPriorityForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_TraderMultiselect, {
                          multiple: true,
                          modelValue: _ctx.tradersFilter,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tradersFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_TrafficGroupMultiselect, {
                          multiple: true,
                          small: "",
                          modelValue: _ctx.trafficGroupsFilter,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.status,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
                          options: ['active', 'expired', 'deleted'],
                          "custom-label": (opt) => _ctx.helper.trans(`labels.${opt}`),
                          multiple: false,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("table", _hoisted_21, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _cache[11] || (_cache[11] = _createElementVNode("th", {
                          class: "text-capitalize-first",
                          style: {"width":"10px"}
                        }, null, -1)),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.trader')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.priority')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.expire_at')), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.traffic_group')), 1),
                        _createElementVNode("th", _hoisted_27, [
                          (_ctx.store.getters.isAdmin || _ctx.store.getters.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.EDIT_MANUAL_PRIORITIES))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditModal())),
                                class: "btn btn-outline-primary btn-sm text-capitalize"
                              }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_b_modal, {
                            title: _ctx.createModalTitle,
                            modelValue: _ctx.createModal,
                            "body-class": "pt-0",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.createModal = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ManualPriorityForm, { ref: "createForm" }, null, 512)
                            ]),
                            footer: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createModal = false)),
                                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                              }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                              _createVNode(_component_LoaderWrapper, {
                                ref: "loaderCreateFrom",
                                zoom: 0.5
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
                                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                                ]),
                                _: 1
                              }, 512)
                            ]),
                            _: 1
                          }, 8, ["title", "modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.id), 1),
                          _createElementVNode("td", null, [
                            (item.isDeleted)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  title: _ctx.helper.trans('labels.deleted'),
                                  class: "fa fa-ban text-danger"
                                }, null, 8, _hoisted_28)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : (item.isActive)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    title: _ctx.helper.trans('labels.active'),
                                    class: "fa fa-circle-play text-success"
                                  }, null, 8, _hoisted_29)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 2,
                                    title: _ctx.helper.trans('labels.expired'),
                                    class: "fa fa-circle-stop text-secondary"
                                  }, null, 8, _hoisted_30)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                          ]),
                          _createElementVNode("td", null, [
                            (item._trader)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  user: item._trader
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.priority), 1),
                          _createElementVNode("td", null, [
                            (item.expiredAt)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.dateHelper.format(item.expiredAt)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.not_set')), 1)
                                ], 64))
                          ]),
                          _createElementVNode("td", null, [
                            (item._trafficGroup)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(item._trafficGroup!.name) + " - " + _toDisplayString(item._trafficGroup!.type), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            (_ctx.store.getters.isAdmin || _ctx.store.getters.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.EDIT_MANUAL_PRIORITIES))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(item)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                }, [
                                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                ], 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (_ctx.store.getters.isAdmin || _ctx.store.getters.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.EDIT_MANUAL_PRIORITIES))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.deletePriority(item.id)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize ms-2"
                                }, _cache[13] || (_cache[13] = [
                                  _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                ]), 8, _hoisted_34))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadList()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}